import i18n from "../../../../constants/i18n";
import ET3Circle from "../../../../core/et3-circle";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getKhattabat101MatchStore from "../../../../stores/khattabat-stores/101m-stores";
import getKhattabat101MMessagingStore from "../../../../stores/khattabat-stores/101m-stores/101m-messaging-store";

const SendSlackAlertsOneOOneM = withLiteObserverAndTheme<{
  matchID: number;
}>((props) => {
  const { theme, matchID } = props;
  const isSlackAlertEnabled =
    getKhattabat101MatchStore(matchID).matchIsSlackAlertsEnabled.get();
  const { colors } = theme;

  return (
    <ET3Div
      width={180}
      height={100}
      alignItems={"center"}
      fDirection={"row"}
      style={{}}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <ET3Circle
        size={13}
        style={{
          cursor: "pointer",
          border: `2px solid ${colors.all.dimGray}`,
          backgroundColor: isSlackAlertEnabled
            ? colors.all.green
            : colors.all.transparent
        }}
        color={""}
        withShadow={false}
        onClick={async () => {
          await getKhattabat101MMessagingStore(
            matchID
          ).updateOneOOneMSlackAlertsDataBase();
        }}
      />
      <Et3Margin top={0} bottom={0} left={10} right={0} />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={20}
        isSpan={false}
        text={i18n.get("SLACK_ALERTS")}
        style={{}}
        color={""}
      />
    </ET3Div>
  );
});

export default SendSlackAlertsOneOOneM;
